var React = require('react');

function PicSliderArrowRightInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0.00181609 7.44545C-0.0332956 8.04581 0.444852 8.55984 1.06979 8.59357C31.0534 10.2119 7.02851 12.4689 64.2235 8.77389L59.3297 14.1981C58.9198 14.6525 58.9709 15.3401 59.4439 15.734C59.9169 16.1278 60.6326 16.0787 61.0426 15.6243L67.7231 8.21962C68.133 7.76523 68.0819 7.07762 67.6089 6.68379L59.9011 0.266035C59.4281 -0.12779 58.7123 -0.0786945 58.3024 0.375695C57.8924 0.830083 57.9435 1.5177 58.4165 1.91152L64.0506 6.60262C7.93333 10.2857 28.3333 6.85714 1.19694 6.41948C0.572003 6.38575 0.0369278 6.84509 0.00181609 7.44545Z","fill":"#1A1A1A"}));
}

PicSliderArrowRightInline.defaultProps = {"width":"68","height":"16","viewBox":"0 0 68 16","fill":"none"};

module.exports = PicSliderArrowRightInline;

PicSliderArrowRightInline.default = PicSliderArrowRightInline;
